import React from 'react';
import { Calendar, User, BookOpen, Target, FileText, Laptop, TrendingUp, ClipboardCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { howItWorks } from '../../mockData';

const iconMap = {
  Calendar,
  User,
  BookOpen,
  Target,
  FileText,
  Laptop,
  TrendingUp,
  ClipboardCheck
};

const HowItWorksSection = ({ scrollToBooking }) => {
  return (
    <section className="section-cream">
      <div className="section-container">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="accent-bar"></div>
          <h2 className="heading-lg mb-6">How It Works</h2>
          <p className="body-lg" style={{ color: 'var(--text-grey)' }}>
            Getting started is simple. Follow these three easy steps to begin your journey to better scores.
          </p>
        </div>
        <div className="grid-3">
          {howItWorks.map((step) => {
            const IconComponent = iconMap[step.icon];
            return (
              <div key={step.id} className="text-center relative">
                <div className="flex justify-center mb-8">
                  <div className="relative">
                    <div className="w-24 h-24 rounded-2xl flex items-center justify-center relative" style={{ background: 'var(--primary-black)' }}>
                      <IconComponent className="w-12 h-12 text-white" />
                    </div>
                    <div className="absolute -top-3 -right-3 w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg" style={{ background: 'linear-gradient(135deg, var(--accent-gold) 0%, #C4C85E 100%)' }}>
                      {step.step}
                    </div>
                  </div>
                </div>
                <h3 className="heading-sm mb-5">{step.title}</h3>
                <p className="body-md" style={{ color: 'var(--text-grey)' }}>{step.description}</p>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-16">
          <Button onClick={scrollToBooking} className="btn-gold text-lg px-14 py-6">
            <Calendar className="w-6 h-6" />
            Book Your Trial Now
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
